import { STORAGE_KEYS, DEFAULT_COST_LINES, DEFAULT_MARGIN } from "./constants";

const safeParse = (raw, fallback) => {
  try {
    return raw ? JSON.parse(raw) : fallback;
  } catch {
    return fallback;
  }
};

const uid = () =>
  Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

export function loadTemplates() {
  return safeParse(localStorage.getItem(STORAGE_KEYS.TEMPLATES), []);
}

export function saveTemplates(templates) {
  localStorage.setItem(STORAGE_KEYS.TEMPLATES, JSON.stringify(templates));
}

export function loadActiveTemplateId() {
  return localStorage.getItem(STORAGE_KEYS.ACTIVE_TEMPLATE) || null;
}

export function saveActiveTemplateId(id) {
  if (id) localStorage.setItem(STORAGE_KEYS.ACTIVE_TEMPLATE, id);
  else localStorage.removeItem(STORAGE_KEYS.ACTIVE_TEMPLATE);
}

export function createDefaultTemplate(name = "Untitled Template") {
  return {
    id: uid(),
    name,
    inputCurrency: "GBP",
    displayCurrency: "GBP",
    margin: DEFAULT_MARGIN,
    costLines: JSON.parse(JSON.stringify(DEFAULT_COST_LINES)),
    products: [createDefaultProduct()],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  };
}

export function createDefaultProduct(overrides = {}) {
  return {
    id: uid(),
    name: "",
    cost: 0,
    quantity: 1,
    ...overrides,
  };
}

export function genId() {
  return uid();
}
